import { SelectionCategories } from '@revelio/iso-utility';

import { LocalSelectionCategories } from '../../../../shared/selection-lists/filter-names';

export const SELECTABLE_API_FILTERS_WITH_ROLE_TAXONOMY = [
  SelectionCategories.JOB_CATEGORY,
  SelectionCategories.ROLE_K150,
  SelectionCategories.ROLE_K1500,
  SelectionCategories.ROLE_K15000,
];

export const SELECTABLE_API_FILTERS = [
  SelectionCategories.COMPANY,
  SelectionCategories.HIGHEST_DEGREE,
  SelectionCategories.ETHNICITY,
  SelectionCategories.GENDER,
  SelectionCategories.COUNTRY,
  SelectionCategories.MSA,
  SelectionCategories.REGION,
  SelectionCategories.SENIORITY,
  SelectionCategories.RICS_K10,
  SelectionCategories.RICS_K400,
];

export const SELECTABLE_STATIC_FILTERS = [
  LocalSelectionCategories.PRESTIGE,
  LocalSelectionCategories.FLIGHT_RISK,
  LocalSelectionCategories.REMOTE_SUITABILITY,
];
